import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithInterceptor } from "src/utils/baseQuery";



export const StationApi = createApi({
    reducerPath: "StationApi",
    baseQuery: baseQueryWithInterceptor,
    tagTypes: ["Station"],
    endpoints: (builder) => ({
        getStationList: builder.query<any, void>({
            query: () => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `inventory/hub`,
                method: "GET",
            }),
        }),
        addStation: builder.mutation<any, void>({
            query: (data) => ({
                headers: {
                    "Content-type": "application/json",
                    "Access-Control-Allow-Origin": "*"
                },
                url: `/inventory/hub`,
                method: "POST",
                body: data,
            }),

        }),
        getStationById: builder.query<any, string>({
            query: (id) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `company/${id}`,
                method: "GET",
            }),
        }),
        fetchStationById: builder.mutation<any, string>({
            query: (id) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `user/search?type=driver&_id=${id}`,
                method: "GET",
            }),
        }),
        getInventoryAvailability: builder.mutation<any, string>({
            query: (imei) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `inventory/${imei}/availability`,
                method: "GET",
            }),
        }),
        searchStationsByName: builder.query<any, any>({
            query: ({ search }) => ({
                headers: {
                    "Content-type": "application/json",
                },
                url: `vehicle/search?company=435345546546546&vehicle=${search}`,
                method: "GET",
            }),
        }),
    }),
});

export const { useGetStationListQuery,
    useAddStationMutation,
    useFetchStationByIdMutation,
    useGetInventoryAvailabilityMutation,
    useSearchStationsByNameQuery
} =
    StationApi;
